/* eslint-disable */ 
import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

export default function Modal({ show, setShow, onClose, children, header }) {
  const [isMounted, setIsMounted] = useState(false)

  const handleClose = () => {
    onClose()
    setShow(false)
  }

  const ref = useRef()

  useEffect(() => {
    const handler = e => {
      if (isMounted && ref.current && !ref.current.contains(e.target)) {
        handleClose()
      }
    }

    document.body.addEventListener('click', handler)

    if (show) {
      setIsMounted(true)
      document.body.style.overflow = 'hidden'
    }
    return () => {
      document.body.style.overflow = null
      document.body.removeEventListener('click', handler)
      setIsMounted(false)
    }
  }, [show, isMounted])

  if (!show) return null

  return createPortal(
    <div className={`offer_modal js-modal ${isMounted ? 'is-open' : ''}`}>
      <div className='__inner' ref={ref}>
        <div className='__header text--no-space'>
          <div>{header}</div>
          <button
            onClick={handleClose}
            className='button-close-modal js-close-modal'
          >
            X
          </button>
        </div>
        <div className='__content'>{children}</div>
      </div>
    </div>,
    document.body
  )
}
